import React, { useEffect, useState } from "react";
import Button from "../../components/FormComponents/Button";
import ChipsInput from "../../components/FormComponents/ChipsInput";
import Input from "../../components/FormComponents/Input";
import SingleSelectBox from "../../components/FormComponents/SingleSelectBox";
import EditPositionFields from "../../components/PositionEditElements/EditPositionFields";
import AppLeftSideBar from "../../components/SideBar/AppLeftSideBar";
import { useAxiosContext } from "../../context/AxiosContext";
import BuilderRightSideBar from "../../Layouts/BuilderRightSideBar";
import BuilderModal from "../../Layouts/Modal/BuilderModal";
import { CustomElementsBar } from "../ApplicationBlock/RecordsViewRenderer/Desktop/NewDesktopRecordviewRenderer";
import { findItemById, updateClassesInLayout, updateOnlyElementConfigInLayout } from "../FlexibleLayout/utils";
import PositionedScreen from "../FlexibleLayout/PositionedScreen";

const PositionedTemplates = () => {
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  const [draggedItem, setDraggedItem] = useState(null);
  const [templateList, setTemplateList] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState({ id: "" });
  const { axiosInstance, handleError, handleSuccess } = useAxiosContext();
  const [layoutConfig, setLayoutConfig] = useState([]);

  const initialTemplateModal = {
    show: false,
    type: "add",
    data: null,
    id: ""
  };

  const [isTemplateModalOpen, setTemplateModalOpen] = useState(initialTemplateModal);

  const openTemplatemodal = () => {
    setTemplateModalOpen({ show: true, type: "add", data: null, id: "" });
  };

  const closeTemplateModal = () => {
    setTemplateModalOpen(initialTemplateModal);
  };

  const openTemplateModalForEdit = () => {
    if (!selectedTemplate?.id) return;

    setTemplateModalOpen({
      show: true,
      type: "edit",
      data: selectedTemplate,
      id: selectedTemplate.id
    });
  };
  const allowedStaticElements = [
    { id: "section", type: "section", name: "Section" },
    { id: "column", type: "column", name: "Column" },
    { id: "block", type: "block", name: "Block" },
    { id: "label", type: "label", name: "Label" },
    { id: "button", type: "button", name: "Button" },
    { id: "html", type: "html", name: "HTML" },
    { id: "field", type: "field", name: "Field" },
    { id: "image", type: "image", name: "Image" },
    { id: "image_field", type: "image_field", name: "Image Field" },
    { id: "icon", type: "icon", name: "icon" },
    { id: "separator", type: "separator", name: "separator" },
    { id: "tab", type: "tab", name: "tab" }
  ];

  const updateTemplateList = (data, type) => {
    if (type === "add") {
      setTemplateList([...templateList, data]);
    }
    if (type === "edit") {
      setTemplateList(templateList.map((item) => (item.id === data.id ? data : item)));
    }
    if (type === "delete") {
      setTemplateList(templateList.filter((item) => item.id !== data.id));
    }
  };

  const handleTemplateAddOrEdit = async (newData) => {
    const { type } = isTemplateModalOpen;
    if (type === "add") {
      try {
        const { data, message } = await axiosInstance.post(`/block-template`, newData);
        setSelectedTemplate(data);
        updateTemplateList(data, "add");
        handleSuccess(message);
      } catch (error) {
        handleError(error);
      }
    }
    if (type === "edit") {
      try {
        const { data, message } = await axiosInstance.patch(`/block-template/${isTemplateModalOpen.data.id}`, newData);
        updateTemplateList(data, "edit");
        handleSuccess(message);
      } catch (error) {
        handleError(error);
      }
    }
    closeTemplateModal();
  };

  const handleSaveTemplate = async () => {
    try {
      const { data, message } = await axiosInstance.patch(`/block-template/${selectedTemplate.id}`, {
        body: layoutConfig
      });
      updateTemplateList(data, "edit");
      handleSuccess(message);
    } catch (error) {
      handleError(error);
    }
  };

  const handleChangeTemplate = (temp) => {
    setSelectedTemplate(temp);
  };

  const deleteSelectedTemplate = async () => {
    try {
      const { message } = await axiosInstance.delete(`/block-template/${selectedTemplate.id}`);
      updateTemplateList({ id: selectedTemplate.id }, "delete");
      setSelectedTemplate({ id: "" });
      handleSuccess(message);
    } catch (error) {
      handleError(error);
    }
  };

  useEffect(() => {
    const fetchAllTemplates = async () => {
      try {
        const { data } = await axiosInstance.get(`/block-template`);
        setTemplateList(data);
      } catch (error) {
        handleError(error);
      }
    };
    fetchAllTemplates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="application_container" style={{ height: "100vh" }}>
      <AppLeftSideBar type={"org"} style={{ flexShrink: 0 }} />
      <div className="dashboard_outer_section w_auto" style={{ flexGrow: 1 }}>
        <div className="dashboard-top-header">
          <h2>Screen Template</h2>
        </div>
        <div className="org-dashboard-page-body">
          <div className="d_flex justify_between">
            <div className="d_flex gap_3">
              <SingleSelectBox
                options={templateList || []}
                valueKey="id"
                labelKey={["name"]}
                selectedData={selectedTemplate.id}
                onChange={handleChangeTemplate}
                isSearch={true}
                containerClassName="w_auto mb_0"
              />
              <button
                className="builder_button secondary"
                onClick={openTemplatemodal}
                style={{ height: "36px", width: "48px" }}
              >
                Add
              </button>
              {selectedTemplate.id && (
                <button
                  className="builder_button secondary"
                  onClick={openTemplateModalForEdit}
                  style={{ height: "36px", width: "48px" }}
                >
                  Edit
                </button>
              )}
              {selectedTemplate.id && (
                <button
                  className="builder_button secondary"
                  onClick={deleteSelectedTemplate}
                  style={{ height: "36px", width: "48px" }}
                >
                  Delete
                </button>
              )}
            </div>
            <button
              className="builder_button primary"
              onClick={handleSaveTemplate}
              style={{ height: "36px", width: "48px" }}
            >
              save
            </button>
          </div>
          <SingleTemplateEditArea
            dragOffset={dragOffset}
            setDragOffset={setDragOffset}
            draggedItem={draggedItem}
            setDraggedItem={setDraggedItem}
            selectedTemplate={selectedTemplate}
            layoutConfig={layoutConfig}
            setLayoutConfig={setLayoutConfig}
          />
        </div>
      </div>
      <CustomElementsBar
        elements={allowedStaticElements}
        setDraggedItem={setDraggedItem}
        setDragOffset={setDragOffset}
        style={{ flexShrink: 0 }}
      />
      <BuilderModal
        isOpen={isTemplateModalOpen.show}
        onClose={closeTemplateModal}
        modalName={isTemplateModalOpen.type + "Template"}
      >
        <CreateOrEditTemplate
          data={isTemplateModalOpen.data}
          type={isTemplateModalOpen.type}
          onSubmit={handleTemplateAddOrEdit}
        />
      </BuilderModal>
    </div>
  );
};

const SingleTemplateEditArea = ({
  setDragOffset,
  dragOffset,
  draggedItem,
  setDraggedItem,
  selectedTemplate,
  layoutConfig,
  setLayoutConfig
}) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [gridSize, setGridSize] = useState(12);
  const [isEditable, setIsEditable] = useState("editable");
  const initialStateOfEditBat = {
    id: "",
    type: "",
    show: false,
    device: "",
    config: null,
    elements: null
  };
  const [editElement, setEditElement] = useState(initialStateOfEditBat);
  const { axiosInstance, handleError } = useAxiosContext();
  const [showTree, setShowTree] = useState(false);

  const toggleMode = () => {
    setSelectedItem(null);
    setIsEditable(isEditable === "editable" ? "view" : "editable");
  };
  const handleChangeGridSize = (e) => {
    setGridSize(parseInt(e.target.value));
  };
  const closeEditBar = () => {
    setEditElement(initialStateOfEditBat);
    setSelectedItem(null);
  };
  const openEditBar = (selectedItem) => {
    const element = findItemById(layoutConfig, selectedItem.id);
    if (!element) return;
    if (element.type === "element") {
      setEditElement({
        id: element.id,
        type: element.config.type,
        show: true,
        device: "",
        config: element.config || null,
        elements: null,
        baseElement: element
      });
    }
    if (element.type === "tab") {
      setEditElement({
        id: element.id,
        type: element.type,
        show: true,
        device: "",
        config: element.tabs,
        elements: null,
        baseElement: element
      });
    }
    if (element.type === "section" || element.type === "column" || element.type === "block") {
      setEditElement({
        id: element.id,
        type: element.type,
        show: true,
        device: "",
        config: element.config || {},
        elements: null,
        baseElement: element
      });
    }
    // Object.values(layoutData.current).forEach((element) => {
    //   const elementType = element.type;
    //   if (!inlineElements.includes(elementType)) {
    //     data.push(element);
    //   }
    // });
  };

  const saveEditElement = (config) => {
    const newLayout = updateOnlyElementConfigInLayout(layoutConfig, editElement.id, config);
    setLayoutConfig(newLayout);
  };

  const handleChangesInClasses = (newClasses, elementId) => {
    const newLayout = updateClassesInLayout(layoutConfig, elementId, newClasses);
    setLayoutConfig(newLayout);
  };

  useEffect(() => {
    const fetchSingleTemplate = async () => {
      if (!selectedTemplate.id) return;
      try {
        const { data } = await axiosInstance.get(`/block-template/${selectedTemplate.id}`);
        // (data);
        setLayoutConfig(data.body || []);
      } catch (error) {
        handleError(error);
      }
    };
    fetchSingleTemplate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTemplate.id]);

  useEffect(() => {
    if (selectedItem) {
      openEditBar(selectedItem);
    } else {
      closeEditBar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItem]);
  if (!selectedTemplate.id)
    return <div className="d_flex justify_center align_center w_100 h_100">Select Template</div>;
  return (
    <>
      <div className="d_flex align_center my_3 gap_3 justify_between">
        <div className="d_flex gap_2">
          <select className="builder_input mr_1 w_fit" value={gridSize} onChange={handleChangeGridSize}>
            <option value={6}>6</option>
            <option value={12}>12</option>
            <option value={24}>24</option>
            <option value={48}>48</option>
            <option value={96}>96</option>
          </select>
          <Button onClick={() => setShowTree((prev) => !prev)} variant="secondary">
            Tree
          </Button>
        </div>
        <div className={`toggle_switch ${isEditable === "editable" ? "active" : ""}`} onClick={toggleMode}>
          <div className="toggle_slider"></div>{" "}
        </div>
      </div>

      <PositionedScreen
        layoutConfig={layoutConfig || []}
        setLayoutConfig={setLayoutConfig}
        draggedItem={draggedItem}
        setDragOffset={setDragOffset}
        setDraggedItem={setDraggedItem}
        dragOffset={dragOffset}
        openEditBar={openEditBar}
        type={isEditable}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        gridSize={gridSize}
        showTree={showTree}
        setShowTree={setShowTree}
      />
      <BuilderRightSideBar
        isOpen={editElement.show}
        onClose={closeEditBar}
        heading={editElement.type}
        size={"small"}
        style={{ overflow: "scroll" }}
      >
        <EditPositionFields
          editElementRightsidebar={editElement}
          saveElement={saveEditElement}
          handleClasses={handleChangesInClasses}
        />
      </BuilderRightSideBar>
    </>
  );
};

const CreateOrEditTemplate = ({ data, type, onSubmit }) => {
  const [templateData, setTemplateData] = useState(() => ({
    body: [],
    name: "",
    tags: [],
    config: {},
    ...(data || {})
  }));

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setTemplateData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleChangeTagList = (list) => {
    setTemplateData((prev) => ({
      ...prev,
      tags: list
    }));
  };

  const handleAddOrEdit = () => {
    onSubmit(templateData);
  };

  return (
    <div className="builder_form">
      <Input
        label="Enter Template Name"
        type="text"
        name="name"
        value={templateData.name || ""}
        onChange={handleChangeInput}
      />
      <ChipsInput inputArray={templateData.tags || []} label="Enter Template Tags" onChange={handleChangeTagList} />
      <Button onClick={handleAddOrEdit} className="text_transform_capitalize">
        {type}
      </Button>
    </div>
  );
};

export default PositionedTemplates;
